import WrapperComponent from '../components/hoc/Wrapper-component';
import { Register } from './registration/Register';
import { RegisterQR } from './registration-qr/RegisterQR';
import { HomeScene } from './home/HomeScene';
import { EnterTel } from './entertel/EnterTel';
import { ClaimScene } from './claims/ClaimScene';
import { ProfileScene } from './profile/ProfileScene';
import { RegisterProduct } from './register-product/RegisterProduct';
import { TermWarranty } from './term/warranty/TermWarranty';
import { WarrantyScanQR } from './warranty-scan-qr/WarrantyScanQR';

export default {
  Register: WrapperComponent('Register')(Register),
  RegisterQR: WrapperComponent('RegisterQR')(RegisterQR),
  HomeScene: WrapperComponent('HomeScene')(HomeScene),
  EnterTel: WrapperComponent('EnterTel')(EnterTel),
  ClaimScene: WrapperComponent('ClaimScene')(ClaimScene),
  ProfileScene: WrapperComponent('ClaimScene')(ProfileScene),
  RegisterProduct: WrapperComponent('RegisterProduct')(RegisterProduct),
  TermWarranty: WrapperComponent('TermWarranty')(TermWarranty),
  WarrantyScanQR: WrapperComponent('WarrantyScanQR')(WarrantyScanQR),
};
